import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticleGuide from "@/pages/artykul/kakobuy-spreadsheet-kompletny-przewodnik/page";
import ArticleVsPandabuy from "@/pages/artykul/kakobuy-vs-pandabuy-porownanie/page";
import ArticleQC from "@/pages/artykul/jak-czytac-zdjecia-qc-kakobuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-kompletny-przewodnik",
    element: <ArticleGuide />,
  },
  {
    path: "/artykul/kakobuy-vs-pandabuy-porownanie",
    element: <ArticleVsPandabuy />,
  },
  {
    path: "/artykul/jak-czytac-zdjecia-qc-kakobuy",
    element: <ArticleQC />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;